import { Resources } from '../../types/resources-types';
import { GetListParams } from '../../types/request-entities-types';

export const getResourceListDataKey = (resource: Resources, params: GetListParams) => JSON.stringify({ resource, ...params });
